jQuery(function($) {

	const backToTopBtn = $('#BackToTop');

	$(window).scroll(function() {

		if ($(this).scrollTop() >= 600 && backToTopBtn.is(":hidden")) {
			backToTopBtn.show();
		}

		if($(this).scrollTop() < 600 && backToTopBtn.is(":visible")) {
			backToTopBtn.hide();
		}

	});

	backToTopBtn.click(function() {
		$("html, body").animate({scrollTop: 0}, 500);
	});

});